import { t } from "i18next";
import { useEffect, useState } from "react";
import { TrainingSessionExercise, TrainingSessionPhase, TrainingSession, emptyTrainingSession } from "../../../../interfaces/training-session";
import { useNavigate, useParams } from "react-router-dom";
import { Accordion, Alert, Col, Nav, Row, Tab } from "react-bootstrap";
import { CoachTrainingSessionPhaseNew } from "./training-phase-new";
import { CoachTrainingSessionPhaseDelete } from "./training-phase-delete";
import { CoachTrainingSessionPhaseEdit } from "./training-phase-edit";
import { CoachTrainingSessionExerciseNew } from "./training-exercise-new";
import { CoachTrainingSessionExerciseDelete } from "./training-exersise-delete";
import { CoachTrainingSessionExerciseEdit } from "./training-exercise-edit";
import { EntityVideos } from "../../../general/entity-videos";
import { cloneTrainingSessionExercise, cloneTrainingSessionPhase, getTrainingSessionSingle, sortDownTrainingSessionExercise, sortDownTrainingSessionPhase, sortUpTrainingSessionExercise, sortUpTrainingSessionPhase, updateTrainingSessionExerciseVideos, updateTrainingSessionPhaseVideos } from "../../../../services/training-session";
import { LoadingSpinner } from "../../../general/loading-spinner";

export function CoachTrainingSessionPhases() {
    const params: any = useParams();
    const navigate = useNavigate();

    const [trainingSession, setTrainingSession] = useState<TrainingSession>(emptyTrainingSession);
    const [loaded, setLoaded] = useState(false);
    const [showAddNew, setShowAddNew] = useState(false);
    const [selectedId, setSelectedId] = useState(0);
    const [showEdit, setShowEdit] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [showAddNewExercise, setShowAddNewExercise] = useState(false);
    const [showEditExercise, setShowEditExercise] = useState(false);
    const [showDeleteExercise, setShowDeleteExercise] = useState(false);
    const [selectedExerciseId, setSelectedExerciseId] = useState(0);

    useEffect(() => {
        getTrainingSessionSingle(params.id)
            .then((response: any) => {
                setTrainingSession(response.data);
                setLoaded(true);
            });
    }, []);

    const handleAddNew = (event: any) => {
        event.preventDefault();
        setShowAddNew(true)
    }

    const handleAddNewOnSave = (p: TrainingSessionPhase) => {
        const newTrainingSession = Object.assign({}, trainingSession);
        newTrainingSession.phases = [
            ...newTrainingSession.phases,
            p
        ];
        setTrainingSession(newTrainingSession);
        setShowAddNew(false);
    }
    
    const handleAddNewOnClose = () => {
        setShowAddNew(false);
    }

    const handleEdit = (event: any) => {
        event.preventDefault();
        setSelectedId(event.currentTarget.dataset.id);
        setShowEdit(true);
    }

    const handleEditOnSave = (changedTrainingSessionPhase: TrainingSessionPhase) => {
        setSelectedId(0);
        const newTrainingSession = Object.assign({}, trainingSession);
        newTrainingSession.phases = newTrainingSession.phases.map((p: TrainingSessionPhase) => {
            if (p.id == changedTrainingSessionPhase.id) {
                return changedTrainingSessionPhase;
            } else {
                return p;
            }
        });
        setTrainingSession(newTrainingSession);
        setShowEdit(false);
    }

    const handleEditOnClose = () => {
        setSelectedId(0);
        setShowEdit(false);
    }

    const handleDelete = (event: any) => {
        event.preventDefault();
        setSelectedId(event.currentTarget.dataset.id);
        setShowDelete(true);
    }

    const handleDeleteOnDelete = (id: number) => {
        setSelectedId(0);
        const newTrainingSession = Object.assign({}, trainingSession);
        newTrainingSession.phases = newTrainingSession.phases.filter((p: TrainingSessionPhase) => p.id != id);
        setTrainingSession(newTrainingSession);
        setShowDelete(false);
    }

    const handleDeleteOnClose = () => {
        setSelectedId(0);
        setShowDelete(false);
    }

    const handleAddNewExercise = (event: any) => {
        event.preventDefault();
        setSelectedId(event.target.dataset.id);
        setShowAddNewExercise(true);
    }

    const handleAddNewExerciseOnSave = (phase_id: number, exercise: TrainingSessionExercise) => {
        const newTrainingSession = Object.assign({}, trainingSession);
        newTrainingSession.phases = newTrainingSession.phases.map((p: TrainingSessionPhase) => {
            if (p.id == phase_id) {
                const newExercises = [
                    ...p.exercises,
                    exercise
                ];
                const newPhase = Object.assign({}, p);
                newPhase.exercises = newExercises;
                return newPhase;
            } else {
                return p;
            }
        });
        setTrainingSession(newTrainingSession);
        setShowAddNewExercise(false);
    }
    
    const handleAddNewExerciseOnClose = () => {
        setSelectedId(0);
        setShowAddNewExercise(false);
    }

    const handleEditExercise = (event: any) => {
        event.preventDefault();
        setSelectedExerciseId(event.currentTarget.dataset.id);
        setShowEditExercise(true);
    }

    const handleEditExerciseOnSave = (exercise: TrainingSessionExercise) => {
        setSelectedId(0);
        const newTrainingSession = Object.assign({}, trainingSession);
        newTrainingSession.phases = newTrainingSession.phases.map((p: TrainingSessionPhase) => {
            const newExercises = p.exercises.map((e: TrainingSessionExercise) => {
                if (e.id == exercise.id) {
                    return exercise;
                } else {
                    return e;
                }
            });
            p.exercises = newExercises;
            return p;
        });
        setTrainingSession(newTrainingSession);
        setShowEditExercise(false);
    }
    
    const handleEditExerciseOnClose = () => {
        setSelectedId(0);
        setShowEditExercise(false);
    }

    const handleDeleteExercise = (event: any) => {
        event.preventDefault();
        setSelectedExerciseId(event.currentTarget.dataset.id);
        setShowDeleteExercise(true);
    }

    const handleDeleteExerciseOnDelete = (id: number) => {
        setSelectedExerciseId(0);
        const newTrainingSession = Object.assign({}, trainingSession);
        newTrainingSession.phases = newTrainingSession.phases.map((p: TrainingSessionPhase) => {
            const newPhase = Object.assign({}, p);
            newPhase.exercises = p.exercises.filter((e: TrainingSessionExercise) => e.id != id);
            return newPhase;
        });
        setTrainingSession(newTrainingSession);
        setShowDeleteExercise(false);
    }

    const handleDeleteExerciseOnClose = () => {
        setSelectedExerciseId(0);
        setShowDeleteExercise(false);
    }

    const handlePhaseVideosChange = (id: number, videos: number[]) => {
        const body = {
            id: id,
            videos: videos
        }
        updateTrainingSessionPhaseVideos(body)
            .then(response => {
                if (response.data.status == 1) {
                    const newTrainingSession: TrainingSession = Object.assign({}, trainingSession);
                    newTrainingSession.phases = trainingSession.phases.map((p: TrainingSessionPhase) => {
                        if (p.id == response.data.data.id) {
                            return response.data.data;
                        } else {
                            return p;
                        }
                    });
                    setTrainingSession(newTrainingSession);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleExcerciseVideosChange = (id: number, videos: number[]) => {
        const body = {
            id: id,
            videos: videos
        }
        updateTrainingSessionExerciseVideos(body)
            .then(response => {
                if (response.data.status == 1) {
                    const newTrainingSession: TrainingSession = Object.assign({}, trainingSession);
                    newTrainingSession.phases = trainingSession.phases.map((p: TrainingSessionPhase) => {
                        const newTrainingSessionPhase: TrainingSessionPhase = Object.assign({}, p);
                        newTrainingSessionPhase.exercises = p.exercises.map((e: TrainingSessionExercise) => {
                            if (e.id == id) {
                                return response.data.data;
                            } else {
                                return e;
                            }
                        });
                        return newTrainingSessionPhase;
                    });
                    setTrainingSession(newTrainingSession);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleClonePhase = (event: any) => {
        event.preventDefault();
        const session = event.currentTarget.dataset.session;
        const body = {
            id: event.currentTarget.dataset.id,
            session: params.id
        }
        cloneTrainingSessionPhase(body)
            .then((response: any) => {
                const newTrainingSession = Object.assign({}, trainingSession);
                newTrainingSession.phases = [
                    ...trainingSession.phases,
                    response.data.data
                ];
                setTrainingSession(newTrainingSession);
                setShowEditExercise(false);
            });
    }

    const handleCloneExercise = (event: any) => {
        event.preventDefault();
        const phase = event.currentTarget.dataset.phase;
        const body = {
            id: event.currentTarget.dataset.id,
            phase: phase
        }
        cloneTrainingSessionExercise(body)
            .then((response: any) => {
                const newTrainingSession = Object.assign({}, trainingSession);
                newTrainingSession.phases = trainingSession.phases.map((p: TrainingSessionPhase) => {
                    if (p.id == phase) {
                        const newTrainingSessionPhase: TrainingSessionPhase = Object.assign({}, p);
                        newTrainingSessionPhase.exercises = [
                            ...p.exercises,
                            response.data.data
                        ];
                        return newTrainingSessionPhase;
                    } else {
                        return p;
                    }
                });
                setTrainingSession(newTrainingSession);
                setShowEditExercise(false);
            });
    }

    const handleSortUp = (event: any) => {
        event.preventDefault();
        const body = {
            id: event.currentTarget.dataset.id,
            session: params.id
        }
        sortUpTrainingSessionPhase(body)
            .then((response: any) => {
                if (response.data.status == 1) {
                    setTrainingSession(response.data.data);
                } else {
                    alert(response.data.message);
                }
            });
    }

    const handleSortDown = (event: any) => {
        event.preventDefault();
        const body = {
            id: event.currentTarget.dataset.id,
            session: params.id
        }
        sortDownTrainingSessionPhase(body)
            .then((response: any) => {
                if (response.data.status == 1) {
                    setTrainingSession(response.data.data);
                } else {
                    alert(response.data.message);
                }
            });
    }

    const handleSortUpExercise = (event: any) => {
        event.preventDefault();
        const id = event.currentTarget.dataset.id;
        const phase = event.currentTarget.dataset.phase;
        const body = {
            id: id,
            phase: phase
        }
        sortUpTrainingSessionExercise(body)
            .then((response: any) => {
                if (response.data.status == 1) {
                    const newTrainingSession: TrainingSession = Object.assign({}, trainingSession);
                    newTrainingSession.phases = newTrainingSession.phases.map((p: TrainingSessionPhase) => {
                        if (p.id == phase) {
                            return response.data.data;
                        } else {
                            return p;
                        }
                    });
                    setTrainingSession(newTrainingSession);
                } else {
                    alert(response.data.message);
                }
            });
    }

    const handleSortDownExercise = (event: any) => {
        event.preventDefault();
        const id = event.currentTarget.dataset.id;
        const phase = event.currentTarget.dataset.phase;
        const body = {
            id: id,
            phase: phase
        }
        sortDownTrainingSessionExercise(body)
            .then((response: any) => {
                if (response.data.status == 1) {
                    const newTrainingSession: TrainingSession = Object.assign({}, trainingSession);
                    newTrainingSession.phases = newTrainingSession.phases.map((p: TrainingSessionPhase) => {
                        if (p.id == phase) {
                            return response.data.data;
                        } else {
                            return p;
                        }
                    });
                    setTrainingSession(newTrainingSession);
                } else {
                    alert(response.data.message);
                }
            });
    }

    const handleBack = (event: any) => {
        event.preventDefault();
        navigate('/coach/training-sessions');
    }
    
    return (
        <div className="training-session-phases-container">
            { !loaded && 
                <LoadingSpinner />
            }
            { loaded && trainingSession.phases != undefined &&
                <div className="phases-content">
                    <h1><a className="go-back" href="#" onClick={ handleBack }>&laquo;</a>{ trainingSession.name }: <span>{ t("phases") }</span></h1>
                    { trainingSession.phases.length > 0 &&
                        <Tab.Container id="phases-tabs" defaultActiveKey={ 'phase-' + trainingSession.phases[0].id}>
                            <Row>
                                <Col lg={3}>
                                    <Nav variant="pills" className="flex-column">
                                        {
                                            trainingSession.phases.map((p: TrainingSessionPhase) => {
                                                const numExercises = p.exercises.length;
                                                return <Nav.Item  key={ 'phase-nav-' + p.id }>
                                                        <Nav.Link eventKey={ 'phase-' + p.id }>
                                                            { p.name }
                                                            <span className="exercises">
                                                                { (numExercises == 0) && <span> ({t("zero_exercises")})</span> } 
                                                                { (numExercises == 1) && <span> ({ t("one_exercise") })</span> } 
                                                                { (numExercises > 1) && <span> ({ numExercises } { t("multiple_exercises") })</span> }   
                                                            </span>
                                                        </Nav.Link>
                                                    </Nav.Item>;
                                            })
                                        }
                                    </Nav>
                                </Col>
                                <Col lg={9}>
                                    <Tab.Content>
                                        {
                                            trainingSession.phases.map((p: TrainingSessionPhase) => {
                                                return <Tab.Pane key={ 'phase-pane-' + p.id } eventKey={ 'phase-' + p.id }>
                                                        <div className="pane-heading">
                                                            <div className="actions">
                                                                <a href="#" className="icon-link edit" title={ t("Edit") } onClick={ handleEdit } data-id={ p.id }>
                                                                    <i className="bi bi-pencil-square"></i>
                                                                </a>
                                                                <a href="#" className="icon-link clone" title={ t("clone") } onClick={ handleClonePhase } data-id={ p.id }>
                                                                    <i className="bi bi-copy"></i>
                                                                </a>
                                                                <a href="#" className="icon-link surt-up" title={ t("clone") } onClick={ handleSortUp } data-id={ p.id }>
                                                                    <i className="bi bi-arrow-up-square"></i>
                                                                </a>
                                                                <a href="#" className="icon-link surt-down" title={ t("clone") } onClick={ handleSortDown } data-id={ p.id }>
                                                                    <i className="bi bi-arrow-down-square"></i>
                                                                </a>
                                                                <a href="#" className="icon-link delete" title={ t("Delete") } onClick={ handleDelete } data-id={ p.id }>
                                                                    <i className="bi bi-trash"></i>
                                                                </a>
                                                            </div>
                                                            <h4>{ p.name }</h4>
                                                            { p.description &&
                                                                <div className="description">
                                                                    <div className="label">
                                                                        <span>{ t("description") }</span>
                                                                    </div>
                                                                    <div className="value">{ p.description }</div>
                                                                </div>
                                                            }
                                                            { p.goals &&
                                                                <div className="goals">
                                                                    <div className="label">
                                                                        <span>{ t("goals") }</span>
                                                                    </div>
                                                                    <div className="value">{ p.goals }</div>
                                                                </div>
                                                            }
                                                        </div>
                                                        <div className="phase-videos">
                                                            <EntityVideos entity_id={ p.id } label={ t("videos") } alert={ t("no_videos_in_phase") }
                                                                videos={ p.videos } updateEnebled={ true } onChange={ handlePhaseVideosChange } />
                                                        </div>
                                                        <div className="pane-exercises">
                                                            {
                                                                p.exercises.length == 0 &&
                                                                <Alert key="info" variant="info">
                                                                    { t("no_exercises_in_phase") }
                                                                </Alert>
                                                            }
                                                            { p.exercises.length > 0 &&
                                                                <div className="exercises">
                                                                    <div className="label">
                                                                        <span>{ t("exercises") }</span>
                                                                    </div>
                                                                    <div className="value">
                                                                        <Accordion defaultActiveKey={ 'exercise-' + p.exercises[0].id }>
                                                                            {
                                                                                p.exercises.map((e: TrainingSessionExercise) => {
                                                                                    return (
                                                                                        <Accordion.Item key={ 'accordion-item-' + e.id } eventKey={ 'exercise-' + e.id }>
                                                                                            <Accordion.Header>{ e.name }</Accordion.Header>
                                                                                            <Accordion.Body>
                                                                                                <div className="exercise-item">
                                                                                                    <div className="actions">
                                                                                                        <a href="#" className="icon-link edit" title={ t("Edit") } onClick={ handleEditExercise } data-id={ e.id }>
                                                                                                            <i className="bi bi-pencil-square"></i>
                                                                                                        </a>
                                                                                                        <a href="#" className="icon-link clone" title={ t("clone") } onClick={ handleCloneExercise } data-phase={ p.id } data-id={ e.id }>
                                                                                                            <i className="bi bi-copy"></i>
                                                                                                        </a>
                                                                                                        <a href="#" className="icon-link surt-up" title={ t("clone") } onClick={ handleSortUpExercise } data-phase={ p.id } data-id={ e.id }>
                                                                                                            <i className="bi bi-arrow-up-square"></i>
                                                                                                        </a>
                                                                                                        <a href="#" className="icon-link surt-down" title={ t("clone") } onClick={ handleSortDownExercise } data-phase={ p.id } data-id={ e.id }>
                                                                                                            <i className="bi bi-arrow-down-square"></i>
                                                                                                        </a>
                                                                                                        <a href="#" className="icon-link delete" title={ t("Delete") } onClick={ handleDeleteExercise } data-id={ e.id }>
                                                                                                            <i className="bi bi-trash"></i>
                                                                                                        </a>
                                                                                                    </div>
                                                                                                    <div className="exercise-heading">
                                                                                                        { e.description.length > 0 &&
                                                                                                            <div className="description">
                                                                                                                <div className="label">
                                                                                                                    <span>{ t("description") }</span>
                                                                                                                </div>
                                                                                                                <div className="value">{ e.description }</div>
                                                                                                            </div>
                                                                                                        }
                                                                                                        { e.goals.length > 0 &&
                                                                                                            <div className="goals">
                                                                                                                <div className="label">
                                                                                                                    <span>{ t("goals") }</span>
                                                                                                                </div>
                                                                                                                <div className="value">{ e.goals }</div>
                                                                                                            </div>
                                                                                                        }
                                                                                                    </div>
                                                                                                    <EntityVideos entity_id={ e.id } label={ t("videos") } alert={ t("no_videos_in_excercise") }
                                                                                                        videos={ e.videos } updateEnebled={ true } onChange={ handleExcerciseVideosChange } />
                                                                                                </div>
                                                                                            </Accordion.Body>
                                                                                        </Accordion.Item>);
                                                                                }) 
                                                                            }
                                                                        </Accordion>
                                                                    </div>
                                                                </div>
                                                            }
                                                            <a className="admin-add-new" href="#" onClick={ handleAddNewExercise } data-id={ p.id }>
                                                                <i className="bi bi-plus-circle"></i> { t("add_exercise") }
                                                            </a>
                                                        </div>
                                                    </Tab.Pane>;
                                            })
                                        }
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    }
                </div>
            }
            {
                <a className="admin-add-new" href="#" onClick={ handleAddNew }>
                    <i className="bi bi-plus-circle"></i>
                </a>
            }
            { showAddNew &&
                <CoachTrainingSessionPhaseNew trainingSessionId={ params.id } onSave={ handleAddNewOnSave } onClose={ handleAddNewOnClose } />
            }
            { showEdit && (selectedId != 0) &&
                <CoachTrainingSessionPhaseEdit id={ selectedId } onSave={ handleEditOnSave } onClose={ handleEditOnClose } />
            }
            { showDelete && (selectedId != 0) &&
                <CoachTrainingSessionPhaseDelete id={ selectedId } onDelete={ handleDeleteOnDelete } onClose={ handleDeleteOnClose } />
            }
            { showAddNewExercise && (selectedId != 0) &&
                <CoachTrainingSessionExerciseNew trainingSessionPhaseId={ selectedId } onSave={ handleAddNewExerciseOnSave } onClose={ handleAddNewExerciseOnClose } />
            }
            { showEditExercise && selectedExerciseId &&
                <CoachTrainingSessionExerciseEdit id={ selectedExerciseId } onSave={ handleEditExerciseOnSave } onClose={ handleEditExerciseOnClose } />
            }
            { showDeleteExercise && selectedExerciseId &&
                <CoachTrainingSessionExerciseDelete id={ selectedExerciseId } onDelete={ handleDeleteExerciseOnDelete } onClose={ handleDeleteExerciseOnClose } />
            }
        </div>
    );
}
